import ActionState from '../schema/ActionState';
import joinButtonStore from '../JoinButtonStore';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import type { ActionButtonState } from '../schema/ActionButtonState';
import transformGroupSmtp from 'owa-group-common/lib/utils/transformGroupSmtp';

export function getGroupActionState(mailboxInfo: MailboxInfo): Map<string, ActionState> {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const joinButtonState = joinButtonStore().groupActionStateByMailboxInfo.get(accountKey);

    if (!joinButtonState) {
        const defaultGroupActionState: ActionButtonState = {
            groupActionState: new Map<string, ActionState>(),
        };
        joinButtonStore().groupActionStateByMailboxInfo.set(accountKey, defaultGroupActionState);
        return defaultGroupActionState.groupActionState;
    }

    return joinButtonState.groupActionState;
}

export function getJoinButtonState(
    mailboxInfo: MailboxInfo,
    groupSmtpAddress: string
): ActionState {
    const groupActionState = getGroupActionState(mailboxInfo);

    return groupActionState.get(transformGroupSmtp(groupSmtpAddress)) ?? ActionState.None;
}

export function hasJoinGroupActionReturned(
    mailboxInfo: MailboxInfo,
    groupSmtpAddress: string
): boolean {
    const actionState = getJoinButtonState(mailboxInfo, groupSmtpAddress);
    return (
        actionState !== undefined &&
        (actionState === ActionState.Succeed || actionState === ActionState.FailureNotice)
    );
}
